module.exports = __webpack_public_path__ + "media/images/icon-mask-truck-96f5ea704af493a77743b18a0d2ffcc8.png";